// A skill a company or candidate adds when theirs is missing. It is created at
// once as `pending` and usable by anyone who adds the same name until a curator
// reviews it (Q79). Role types work the same way (Q77).
import { z } from 'zod';

export const skillSuggestionInputSchema = z.object({
  name: z.string().trim().min(2).max(60),
});

/** Most pending skills one person may have waiting for review. */
export const MAX_PENDING_SKILLS = 10;

// A role type a company or candidate adds when none fits. It is created at
// once as `pending`; only people using it see it (others reach it by its exact
// name) until a curator reviews it (Q77). The industry picked on the form is
// stored as its first tag.
export const roleTypeSuggestionInputSchema = z.object({
  name: z.string().trim().min(2).max(60),
  family: z.string().trim().min(1).max(80),
  industryId: z.uuid().nullable().optional(),
  note: z.string().trim().max(300).nullable().optional(),
});
export type RoleTypeSuggestionInput = z.infer<typeof roleTypeSuggestionInputSchema>;

/** Most pending role types one person may have waiting for review. */
export const MAX_PENDING_ROLE_TYPES = 5;
